


















































































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyType, Product, SurveyStatusType, SurveyStatusResult } from "@/interfaces";

import { AuthModule, SurveyModule } from "@/store";
import { getInitiativeHospitality, deleteInitiativeHospitality } from "@/services";
import { notifyError, notifySuccess } from "@/common/notify";

import { date } from "quasar";

@Component
export default class HospitalityInitiative extends Vue {
  @AuthModule.bindings.State
  status!: SurveyStatusResult;

  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  elements: Product[] = [];

  loading = false;

  filteredData: Product[] = [];

  searchText = "";
  planningYear: number | null = null;

  mounted() {
    const planningYears = [...this.status.planning_years];
    const planningYear = planningYears.pop();

    if (planningYear) {
      this.planningYear = planningYear;
    }

    this.loadMatrix();
    this.setSurveyType(SurveyType.INITIATIVE_HOSPITALITY);
  }

  async loadMatrix() {
    try {
      this.loading = true;
      this.elements = this.filteredData = await getInitiativeHospitality(
        this.planningYear === null ? 2022 : this.planningYear,
      );
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  goToSurvey() {
    this.$router.push(`survey/${SurveyType.INITIATIVE_HOSPITALITY}`).catch(error => console.log(error));
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.elements.filter(element =>
        element.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.elements;
    }
  }

  openShowAttractor(element: Product) {
    if (element.surveys.length > 0) {
      this.$router
        .push(`survey/${SurveyType.INITIATIVE_HOSPITALITY}/${element.surveys[0].id}`)
        .catch(error => console.log(error));
    }
  }

  getAttractorDate(element: Product) {
    if (element.surveys.length > 0) {
      return date.formatDate(element.surveys[0].updated_at, "DD/MM/YYYY HH:mm");
    }

    return "";
  }

  onDeleteAttractor(element: Product) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: `Sei sicuro di volere eliminare l'iniziativa <strong>${element.name}</strong>`,
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteAttractorAction(element);
      });
  }

  async deleteAttractorAction(element: Product) {
    try {
      await deleteInitiativeHospitality(element.id);
      this.loadMatrix();
      this.searchText = "";
      notifySuccess("Iniziativa rimossa con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare l'iniziativa!");
    }
  }

  get statusLabelClass() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "text-positive";
        case SurveyStatusType.IN_PROGRESS:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "Completato";
        case SurveyStatusType.IN_PROGRESS:
          return "Da Completare";
        default:
          return "Indefinito";
      }
    };
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: (row: Product) => (row.surveys.length > 0 ? this.statusLabel(row.surveys[0].status) : ""),
        align: "left",
        sortable: true,
      },
      {
        label: "Ultima modifica",
        name: "date",
        field: (row: Product) =>
          row.surveys.length > 0 ? date.formatDate(row.surveys[0].updated_at, "DD/MM/YYYY HH:mm") : "",
        align: "left",
        sortable: true,
      },
      { name: "actions", align: "center" },
      { name: "delete", align: "center" },
    ];
  }
}
